module.exports = __webpack_public_path__ + "img/logo_github.a4679030.png";